import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path fill=\"#FFDA44\" d=\"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12\"></path><path fill=\"#D80027\" d=\"M13.825 23.862a11.94 11.94 0 0 0 5.271-2.185L12 12zM10.174.138a11.94 11.94 0 0 0-5.272 2.185L12 12zM4.902 21.677a11.94 11.94 0 0 0 5.272 2.185L11.999 12zM2.322 4.902a11.94 11.94 0 0 0-2.185 5.272l11.862 1.825zM.137 13.825a11.94 11.94 0 0 0 2.185 5.272L11.999 12zM23.862 10.174a11.94 11.94 0 0 0-2.185-5.271L12 11.999z\"></path><path fill=\"#D80027\" d=\"M19.096 2.323A11.94 11.94 0 0 0 13.825.138L12 12zM21.677 19.097a11.94 11.94 0 0 0 2.185-5.272L12 12z\"></path><path fill=\"#D80027\" d=\"M11.998 16.174a4.174 4.174 0 1 0 0-8.348 4.174 4.174 0 0 0 0 8.348\"></path><path fill=\"#FFDA44\" d=\"M12.002 15.13a3.13 3.13 0 1 0 0-6.261 3.13 3.13 0 0 0 0 6.26\"></path>", 5)
const _hoisted_7 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_7]))
}
export default { render: render }